import React from 'react';

import { getSubdomain, isSaaSSubdomain } from 'utils/getSubdomain';
import SaaSVHeader from './SaaSVHeader';
import Header from './Header';

const HorizontalHeader = () => {
  return isSaaSSubdomain() ? <SaaSVHeader /> : <Header />;
};

export default HorizontalHeader;
